import React from 'react';
import type { FC } from 'react';
import { useIntl } from 'react-intl-next';
import { css } from '@compiled/react';

import Heading from '@atlaskit/heading';
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Inline, Stack, Text, xcss } from '@atlaskit/primitives';
import PresenterModeIcon from '@atlaskit/icon/core/presenter-mode';

import { i18n } from '../automation-modal/AutomationModalHeader';
import { useAutomationMenu } from '../common/ConfluenceManualRulesContainer';

type AutomationModalHeaderProps = {
	contentTitle: string;
	title: string;
};

const iconStyle = xcss({
	marginRight: 'space.150',
	backgroundColor: 'color.background.accent.green.subtlest',
	borderRadius: 'radius.small',
});

const contextHintStyle = xcss({
	marginTop: 'space.150',
});

const HeadingStyles = css({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/design-system/use-tokens-typography
	h3: { fontSize: `20px !important` },
});

export const AutomationRovoButtonHeader: FC<AutomationModalHeaderProps> = ({
	contentTitle,
	title,
}) => {
	const { formatMessage } = useIntl();

	const { initialised, rules } = useAutomationMenu();

	const showHint = initialised && rules.length > 0;
	const contextHint = formatMessage(i18n.modalHeaderContextHint, {
		contentTitle,
		b: (chunks: React.ReactNode[]) => <Text weight="bold">{chunks}</Text>,
	});

	return (
		<Stack>
			<Inline alignBlock="center">
				<Box
					xcss={iconStyle}
					paddingInline="space.050"
					paddingBlock="space.025"
					testId="automation-header-icon"
				>
					<PresenterModeIcon label="" color={token('color.icon.accent.green')} />
				</Box>
				<div css={HeadingStyles}>
					<Heading size="medium">{title}</Heading>
				</div>
			</Inline>
			{showHint && (
				<Box xcss={contextHintStyle}>
					{contextHint}
					<div>{formatMessage(i18n.modalHeaderContextDescription)}</div>
				</Box>
			)}
		</Stack>
	);
};
